import { render, staticRenderFns } from "./UserPreferences.vue?vue&type=template&id=54df234e&"
import script from "./UserPreferences.vue?vue&type=script&lang=ts&"
export * from "./UserPreferences.vue?vue&type=script&lang=ts&"
import style0 from "./UserPreferences.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports